module.exports = __webpack_public_path__ + "img/gate.da28bc3e.svg";